import { useModalStore } from "@/stores/use-modal-store";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { MemoryScore } from "@/api/studio/insights/types/memory.type";
import { MemoryEmotionIndicator } from "@/components/ui/indicator";
import { useEffect } from "react";

/* Memory score data - using shared constants */
const memoryScores: MemoryScore[] = [5, 4, 3, 2, 1];

/*
 * AOIMemoryInfoModal component
 *
 * This modal displays information about the AOI memory scores and their meanings.
 */
export const AOIMemoryInfoModal = () => {
  /* Hooks */
  const { close, setConfig } = useModalStore((state) => state.modalActions);
  useEffect(() => {
    setConfig({
      className: "w-full max-w-[400px]",
    });
  }, [setConfig]);

  /* Render */
  return (
    <div className="flex flex-col gap-4">
      {/* Header */}
      <div className="flex items-center justify-center relative">
        <h2 className="text-xl font-semibold">AOI elements</h2>
        <XMarkIcon onClick={close} className="size-5 cursor-pointer absolute right-0 hover:opacity-70 transition-opacity" />
      </div>

      {/* Description */}
      <p className="text-center text-base-content">How likely an element is retained in viewers memory:</p>

      {/* Memory Scores List */}
      <div className="flex flex-col">
        {memoryScores.map((score) => (
          <div key={score} className="flex items-center py-2.5 px-4 bg-base-200 first:rounded-t-lg last:rounded-b-lg border-b-2 border-base-100 last:border-b-0">
            <div className="flex items-center px-1.5">
              <MemoryEmotionIndicator score={score} type="memory" size="small" textSize="sm" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
